<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import { t } from "$lib/i18n";
  import { translateLabel } from "$lib/philatelic-labels";
  import { Check } from "@lucide/svelte";

  let {
    labels = $bindable<string[]>([]),
    isReadonly = false,
    availableLabels,
    containerClass = "grid grid-cols-4 items-center gap-4",
  }: { labels: string[]; isReadonly?: boolean; availableLabels: string[]; containerClass?: string } = $props();

  let isOpen = $state(false);

  function toggle(key: string) {
    if (labels.includes(key)) {
      labels = labels.filter(k => k !== key);
    } else {
      labels = [...labels, key];
    }
  }
</script>

{#if isReadonly}
  {#if labels.length > 0}
    <div class="grid grid-cols-4 items-center gap-4">
      <span class="text-right text-sm font-medium">{$t('labels.button')}:</span>
      <div class="col-span-3 flex flex-wrap gap-1">
        {#each labels as key}
          <span class="rounded-full border px-2 py-0.5 text-xs">{translateLabel(key)}</span>
        {/each}
      </div>
    </div>
  {/if}
{:else}
  <div class={containerClass}>
    <div class="col-span-4 relative">
      <Button variant="outline" type="button" onclick={() => isOpen = !isOpen}>
        {$t('labels.button')}{labels.length > 0 ? ` (${labels.length})` : ''}
      </Button>
      {#if isOpen}
        <!-- Backdrop to close on outside click -->
        <div
          class="fixed inset-0 z-10"
          role="presentation"
          onclick={() => isOpen = false}
        ></div>
        <div class="absolute left-0 bottom-full z-20 mb-1 min-w-56 rounded-md border bg-background shadow-md">
          {#each availableLabels as key}
            <button
              type="button"
              class="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-muted text-left"
              onclick={() => toggle(key)}
            >
              <span class="flex h-4 w-4 shrink-0 items-center justify-center">
                {#if labels.includes(key)}
                  <Check size={14} />
                {/if}
              </span>
              {translateLabel(key)}
            </button>
          {/each}
        </div>
      {/if}
    </div>
  </div>
{/if}
